import { getSessionAgentInformation } from "app/utils/utility.service";
import { getSessionBrokerInformation } from "app/utils/utility.service";
import { getSessionUserInformation } from "app/utils/utility.service";
import { clearHomePurchaseValues } from "app/views/home-purchase/HomePurchaseStep3/HomePurchaseStep3Slice";
import { Menu } from 'primereact/menu';
import { Fragment, useRef, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Partials.scss";
import { logout } from "app/views/sessions/firebase";
import { useMediaQuery } from "react-responsive";
import { Accordion, AccordionTab } from "primereact/accordion";
import { getSubscriptionList } from "app/views/subscription/subscription.service";
import SubscriptionDialog from "./SubscriptionDialog";

const Header = () => {
    const menu = useRef(null);
    const [disableLogoLink, setDisableLogoLink] = useState(false);
    const sessionValues = getSessionUserInformation();
    const agentValues = getSessionAgentInformation();
    const brokerValues = getSessionBrokerInformation();
    const [features, setFeatures] = useState([]);
    const navigate  = useNavigate();
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const [featureModal, setFeatureModal] = useState(false);
    const [isDialog, setIsDialog] = useState(false);
    const menuLeft = useRef(null);
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [currentPlan, setCurrentPlan] = useState(null);
    const [featureAccessMap, setFeatureAccessMap] = useState(null);
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
      })
    /*const [toggle, setToggle] = useState("");
    const expand = toggle ? "width1" : ""; */

    let items = [];
    
    const myProfileItems = [
        {
            label: "My Profile",
            feature: "my_profile",
            command: () => {
                window.location.hash = `/my-profile`;
            },
        }]
 const mySubscriptionItems = [
        {
            label: "My Profile",
            feature: "my_profile",
            command: () => {
                window.location.hash = `/my-profile`;
            },
        }]

    const mobileProfileItems = [
        {
            label: "Home Ownership",
            feature: "home",
            command: () => {
                window.location.hash = `/home-purchase/step3/tab1`;
            },
        },
        {
            label: "Investment",
            feature: "investment",
            command: () => {
                window.location.hash = `/home-purchase/investment/analysis`;
            },
        },
        {
            label: "Real Estate",
            feature: "real_estate",
            command: () => {
                window.location.hash = `/home-purchase/portfolio/realestate`;
            },
        },
        {
            label: "Stock Market",
            feature: "stock_market",
            command: () => {
                window.location.hash = `/home-purchase/portfolio/financials`;
            },
        },
        {
            label: "Commodities",
            feature: "commodities",
            command: () => {
                window.location.hash = `/home-purchase/portfolio/commodities`;
            },
        },
        {
            label: "Cryptocurrency",
            feature: "cryptocurrency",
            command: () => {
                window.location.hash = `/home-purchase/portfolio/crypto`;
            },
        },
        {
            label: "Accounts",
            feature: "accounts",
            command: () => {
                window.location.hash = `/home-purchase/portfolio/accounts`;
            },
        },
        {
            label: "Permit and Work History",
            feature: "permit_work_history",
            command: () => {
                window.location.hash = `/home-purchase/transactions/workhistory`;
            },
        },
        {
            label: "Payments",
            feature: "payments",
            command: () => {
                window.location.hash = `/home-purchase/transactions/payments`;
            },
        },
        {
            label: "Life Events",
            feature: "life_events",
            command: () => {
                window.location.hash = `/home-purchase/milestone/lifeevents`;
            },
        },
        {
            label: "Depletion",
            feature: "depletion",
            command: () => {
                window.location.hash = `/home-purchase/milestone/depletion`;
            },
        },
        
        {
            label: "Reports",
            feature: "reports",
            command: () => {
                window.location.hash = `/home-purchase/report/list`;
            },
        },
        
        {
            label: "Settings",
            feature: "settings",
            command: () => {
                window.location.hash = `/agent-access`;
            },
        },
         {
            label: "My Subscription",
            command: () => {
                handleSubscriptionModal();
            },
        },
        ]
    const commonMenuItems = [
       
        {
            label: "Logout",
            command: () => {
                dispatch(clearHomePurchaseValues());
                sessionStorage.clear();
                logout();
                navigate("/");
            },
        },
    ];

    items = [...commonMenuItems];

    

    if(disableLogoLink === false) {
        
        
        // Filter menu items based on feature access
        items = items.filter(item => {
            // Always allow items without feature property (like Logout)
            if (!item.feature) return true;
            
            const featureName = featureAccessMap?.[item.feature];
            const isAllowed = featureName && currentPlan && featureName[currentPlan] === true;
            return isAllowed;
        });
        items = [...myProfileItems,...commonMenuItems];
    } 
    if(sessionValues && sessionValues.roleId === 4) {
        if((pathname.search("/home-purchase/step3") === 0 ||
            pathname.search("/home-purchase/investment") === 0) ||
            pathname.search("/home-purchase/portfolio") === 0 ||
            pathname.search("/home-purchase/transactions") === 0 ||
            pathname.search("/home-purchase/report") === 0 ||
            pathname.search("/my-profile") === 0 ||
            pathname.search("/agent-access") === 0 ||
            pathname.search("/home-purchase/milestone") === 0) {
           
            // Filter mobile menu items based on feature access
            const filteredMobileItems = mobileProfileItems.filter(item => {
                // Always allow items without feature property (like Logout)
                if (!item.feature) return true;
                
                // Always allow essential items
                if (item.label === "Home" || item.label === "My Profile" || item.label === "Settings") return true;
                
                const featureName = featureAccessMap?.[item.label];
                const isAllowed = featureName && currentPlan && featureName[currentPlan] === true;
                return isAllowed;
            });
            
            items = [...filteredMobileItems,...items];
        }
    }
    useEffect(() => {
        if(pathname.search("/home-purchase/step1") === 0 || pathname.search("/home-purchase/step2") === 0) {
            setDisableLogoLink(true);
        } else {
            setDisableLogoLink(false);
        }
         const stored = sessionStorage.getItem("subscriptionData");
    
    if (stored && stored !== "null" && stored !== "undefined" && stored.trim() !== "") {
      try {
        const parsedData = JSON.parse(stored);
        setSubscriptionData(parsedData);
        
        const featureAccessMap = parsedData?.features?.reduce((acc, f) => {
          acc[f.name] = f.access;
          return acc;
        }, {});
        setFeatureAccessMap(featureAccessMap);
        
        const { currentPlan } = parsedData;
        setCurrentPlan(currentPlan);
      } catch (error) {
        console.error("Error parsing subscription data:", error);
        console.log("Using default subscription data");
        setSubscriptionData({
          currentPlan: 'Basic',
          features: []
        });
        setFeatureAccessMap({});
        setCurrentPlan('Basic');
      }
    } else {
      console.log("Initial load - no subscription data found, using default");
      // Set default values when no subscription data exists
      setSubscriptionData({
        currentPlan: 'Basic',
        features: []
      });
      setFeatureAccessMap({});
      setCurrentPlan('Basic');
    }

    },[pathname])

    const handleSubscriptionModal = () => {
     
      setFeatureModal(!featureModal);
      setIsDialog(true);
    };
    const renderSubscriptionModal = () => (
      <SubscriptionDialog featureModal={featureModal} 
      handleSubscriptionModal={handleSubscriptionModal}
      isDialog={isDialog}

      />
    );
    let superAdminMenuItems = [
        {
            label: "Dashboard",
            command: () => {
                window.location.hash = "/dashboard";
            }
        },
        {
            label: "Broker/Team Leader List",
            command: () => {
                window.location.hash = "/brokers";
            }
        },
        {
            label: "Agent List",
            command: () => {
                window.location.hash = "/agents";
            }
        },
        {
            label: "Client List",
            command: () => {
                window.location.hash = "/clients";
            },
        },
        {
            label: "Unassigned Clients",
            command: () => {
                window.location.hash = "/clients/new";
            }
        },
        {
            label: "Component Master",
            command: () => {
                window.location.hash = "/componentmaster";
            }
        },
        {
            label: "Subscription Configuration",
            command: () => {
                window.location.hash = "/subscription";
            }
        },
        
    ];

    let brokerMenuItems = [
        {
            label: "Dashboard",
            command: () => {
                window.location.hash = "/dashboard";
            }
        },
        {
            label: "Agent List",
            command: () => {
                window.location.hash = `/agents/?userId=${sessionValues.id}`;
            },
        },
        {
            label: "Client List",
            command: () => {
                window.location.hash = `/clients/?userId=${sessionValues.id}`;
            },
        },
         {
            label: "My Subscription",
            command: () => {
                window.location.hash = `/subscription/dialog?broker`;
            },
        },
    ];
    let agentMenuItems = [
        {
            label: "Dashboard",
            command: () => {
                window.location.hash = "/dashboard";
            }
        },
        {
            label: "Client List",
            command: () => {
                window.location.hash = `/clients/?userId=${sessionValues.id}`;
            },
        },
        {
            label: "My Subscription",
            command: () => {
                window.location.hash = `/subscription/dialog?agent`;
            },
        },
    ];

    
    if(sessionValues?.roleId === 1) {
        items = [...superAdminMenuItems, ...items];
    }
    if(sessionValues?.roleId === 2) {
        items = [...brokerMenuItems, ...items];
    }
    if(sessionValues?.roleId === 3) {
        items = [...agentMenuItems, ...items];
    }
    const header = 
        <Fragment>
            <div className="Header">
                <div className="left">
                {/* {(!isDesktopOrLaptop && (pathname.search("/home-purchase/step3") === 0) ) && (
                    <Fragment>
                        <Menu
                            model={items}
                            popup
                            ref={menu}
                            id="popup_menu"
                        />
                        <i
                            className="pi pi-ellipsis-v ml-2"
                            style={{ fontSize: "1.5em", cursor: "pointer", color:"darkgrey" }}
                            onClick={(event) => menu.current.toggle(event)}
                            aria-controls="popup_menu"
                            aria-haspopup
                        ></i>
                    </Fragment>
                )} */}
                    {disableLogoLink ? (
                        <img src="/myhouserlogo.png" alt="Company" className="ml-2"/>
                    ) : (
                        <Link to="/">
                            <img src="/myhouserlogo.png" alt="Company" className={`${isDesktopOrLaptop ? "" : "ml-2"}`}/>
                        </Link>
                    )}
                    
                </div>
                <div className="main">
                    <Fragment>
                        {sessionValues &&
                            sessionValues.roleId === 2 &&
                            sessionValues?.companyImagePath  && (
                                <Fragment>
                                    <img
                                        className="ml-4 mr-4"
                                        src={`${process.env.REACT_APP_API_BASE_URL}/fetchImages/${sessionValues?.companyImagePath}`}
                                        alt="Profile"
                                        style={{
                                            width: "auto",
                                            height: "70px",
                                        }}
                                    />
                                </Fragment>
                            )}
                        {brokerValues &&
                            brokerValues.id &&
                            brokerValues.companyImagePath  && (
                                <Fragment>
                                    <div style={isDesktopOrLaptop ? { marginRight: "15rem" } : {}} >
                                        <img
                                            className="ml-4 mr-4"
                                            src={`${process.env.REACT_APP_API_BASE_URL}/fetchImages/${brokerValues?.companyImagePath}`}
                                            alt="Company"
                                            style={{
                                                width: "auto",
                                                height: "70px",
                                            }}
                                        />
                                        <div className="text-center">
                                            <label
                                                style={isDesktopOrLaptop ? { fontWeight: "500" } : {"font-size":"1.2rem"}}
                                            >{`Broker: ${brokerValues.firstName} ${brokerValues.lastName}`}</label>
                                        </div>
                                    </div>
                                </Fragment>
                            )}
                        {agentValues &&
                            agentValues.id &&
                            agentValues.profileImagePath  &&(
                                <Fragment>
                                    <div>
                                        <img
                                            className="ml-4 mr-4"
                                            src={`${process.env.REACT_APP_API_BASE_URL}/fetchImages/${agentValues?.profileImagePath}`}
                                            alt="Profile"
                                            style={{
                                                width: "auto",
                                                height: "70px",
                                            }}
                                        />
                                        <div className="text-center">
                                            <label
                                                style={isDesktopOrLaptop ? { fontWeight: "500" } : {"font-size":"1.2rem"}}
                                            >{`Agent: ${agentValues.firstName} ${agentValues.lastName}`}</label>
                                        </div>
                                    </div>
                                </Fragment>
                            )}
                    </Fragment>
                </div>
      
                {!!sessionValues?.firstName && (
                    <Fragment>
                        <div className="right">
                            {isDesktopOrLaptop ? (
                            <Fragment>
                                <h4 style={{color:"#6c757d"}}>Hi {sessionValues?.firstName}</h4>
    
                            </Fragment>
                            ):
                            <h4>Hi</h4>
                            }
                          
                            <Menu
                                model={items}
                                popup
                                ref={menu}
                                id="popup_menu"
                            />
                            <i
                                className="pi pi-angle-down ml-2"
                                style={{ fontSize: "1em", cursor: "pointer",color: "#6c757d"}}
                                onClick={(event) => menu.current.toggle(event)}
                                aria-controls="popup_menu"
                                aria-haspopup
                            ></i>
                         

                            {/* <div className="mr-5">
                                <Link to="/session/signin/step1">Login</Link>
                            </div>
                            <div>
                                <Link to="/session/signup">Register</Link>
                            </div> */}
                        </div>

                    </Fragment>
                    
                )}
              
                  </div>
                 
                 {(sessionValues?.roleId === 2 || sessionValues?.roleId === 3) && (
                     <div style={{marginLeft:"114rem",marginTop:"-2rem"}}>
                    <label style={{color:"#6c757d", fontSize:"1.3rem",fontWeight:"600",  margin: "0.25rem 0 0.5rem 0"}}>
                        {sessionValues?.roleId === 2 ? 'Broker' : 'Agent'}
                    </label>
                       </div>
                )} 
               
          
              
        </Fragment>

    return (
        <div className="container-fluid">
            {/* <div className={`Header ${expand}`}> */}
         {/*   {isDesktopOrLaptop ? (
                 <Fragment>	
                {header}
                </Fragment>
            ) : (
               
             }   <Accordion className="" expandIcon={<i className="pi pi-plus"></i>
                } collapseIcon={<i className="pi pi-minus"></i>}>
            <AccordionTab>*/}
                        {header}
                  {/*}  </AccordionTab>
        </Accordion>*/}
               
            {featureModal && renderSubscriptionModal()}
        </div>
    );
};

export default Header;
